import React from 'react';
import { IconProps } from '.';

const SvgColoredMedal = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#878F91' d='M4 1.333h5.333l5.334 13.334H9.333L4 1.333Z' />
      <path fill='#606567' d='M14.666 1.333H20l-5.334 13.334H9.333l5.333-13.333Z' />
      <circle cx={12} cy={14.667} r={8} fill='#7E96F9' />
      <circle cx={12} cy={14.667} r={6} fill='#A3B4FB' />
    </svg>
  );
};

export default SvgColoredMedal;
